//设置token请求头和content-type
import Axios from "axios";
import Qs from 'qs'
import router from '../../router'
import VueResource from 'vue-resource'
import Vue from 'vue' //为https接口服务
import Fingerprint2 from 'fingerprintjs2'; // 引入fingerprintjs2  浏览器指纹引入
import { Message } from 'element-ui'

Vue.use(VueResource) //为https接口服务
Vue.prototype.$axios = Axios  //全局注册，使用方法为:this.$axios
Axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
//----------------浏览器指纹呐  start----------------------
// 浏览器指纹
const fingerprint = Fingerprint2.get((components) => { // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
	const values = components.map(component => component.value); // 配置的值的数组
	const murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
	localStorage.setItem('browserId', murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
});
//================== 浏览器指纹呐  end=========================

//请求拦截  
axios.interceptors.request.use(function (config) {
	let token = window.localStorage.getItem('token');
	// let browserId = window.localStorage.getItem('browserId');
	// config.headers['projectSource'] = 'dyy-pc'
	config.data = Qs.stringify(config.data)
	if (config.jsonData) {
		config.headers['Content-Type'] = 'application/json;charset=UTF-8'
		config.data = JSON.stringify(config.jsonData)
	} else if (config.formData) {
		var formData = new FormData()
		for (var i in config.formData) {
			formData.append(i, config.formData[i])
		}
		config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
		config.data = formData;
	}
	if (token) {
		config.headers.common['token'] = token;
	}
	//请求头 浏览器指纹参数
	config.headers.common['browserId'] = 'Host by MidOffice';
	return config;
}, function (error) {
	console.info("error: ");
	console.info(error);
	return Promise.reject(error);
});
// 添加一个响应拦截器
Axios.interceptors.response.use(function (response) {
	if (response.data && response.data.code) {
		if (response.data.code === 1) {
			return response
		}else if (parseInt(response.data.code) === -1) {
			router.replace({ path: "/login" })
			return;
		}else if (parseInt(response.data.code) === 0) {
			router.replace({ path: "/login" })
			return;
		}
	}
	if(response.config.url.indexOf('jbb-data') != -1 && response.data.code != '200'){
		Message({
            message: response.data.data || response.data.message,
            type: 'error'
        })
	}
	return response;
}, function (error) {
	console.dir(error);
	return Promise.reject(error);
})
Vue.prototype.baseUrl = Axios.defaults.baseURL



// WEBPACK FOOTER //
// ./src/assets/js/index.js